import * as React from 'react';
import { SVGProps } from 'react';

const SvgAtm = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.1 15.969h1.8v-.844h.9c.495 0 .9-.38.9-.844V11.75c0-.464-.405-.844-.9-.844h-2.7v-.844h3.6V8.374h-1.8V7.53h-1.8v.844h-.9c-.495 0-.9.38-.9.844v2.531c0 .464.405.844.9.844h2.7v.844H9.3v1.688h1.8v.844zM19.2 5H4.8c-.999 0-1.791.751-1.791 1.687L3 16.812c0 .937.801 1.688 1.8 1.688h14.4c.999 0 1.8-.751 1.8-1.688V6.687c0-.937-.801-1.688-1.8-1.688zm0 11.812H4.8V6.687h14.4v10.125z" />
  </svg>
);

export default SvgAtm;
